<template>
	<div>
		<div class="flex justify-center">
			<img class="px-4 w-1/2" src="../../../assets/logo.svg" alt="IMD-CONNECT.PRO" />
		</div>
		<div class="justify-start pt-6" style="color: #333; white-space: break-spaces">
			{{ $t('onboarding_parameter_hint') }}
		</div>
	</div>
</template>
<script>
export default {
	name: 'OnboardingWelcome',
	mixins: [],
	components: {},
	data() {
		return {};
	},
};
</script>
